/*
define global runtime environment
 */
declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

type AppEnv = {
  VITE_VERSION: string;
  VITE_ENVIRONMENT: "local" | "dev" | "staging" | "prod";
  VITE_MANAGER_API_BASE_URL: string;
  VITE_SETTINGS_API_BASE_URL: string;
  VITE_LIVEOPS_API_BASE_URL: string;
  VITE_GRAPHQL_ENDPOINT_URL: string;
  VITE_AUTH_DOMAIN: string;
  VITE_AUTH_AUDIENCE: string;
  VITE_AUTH_CLIENT_ID: string;
  VITE_AUTH_CALLBACK_REDIRECT_URL?: string;
  VITE_AUTH_LOGOUT_REDIRECT_URL?: string;
  VITE_AUTH0_JWKS_URL: string;
  VITE_LOGROCKET_KEY?: string;
  VITE_SENTRY_DSN?: string;
  VITE_BASE_URL?: string;
};

const areRuntimeEnvironmentsSetUp = window.__ENV__ && Object.keys(window.__ENV__).length > 0;

const buildWithBaseUrl = (configuration: AppEnv, environmentVariable?: string | null) => {
  if (configuration && configuration.VITE_BASE_URL && environmentVariable) {
    return `${configuration?.VITE_BASE_URL}${environmentVariable}`;
  }
  return "";
};
const configuration = areRuntimeEnvironmentsSetUp ? window.__ENV__ : import.meta.env;
export default {
  version: configuration?.VITE_VERSION,
  environment: configuration?.VITE_ENVIRONMENT as "local" | "dev" | "staging" | "prod",
  apiUrl: configuration?.VITE_MANAGER_API_BASE_URL,
  settingsApiBaseUrl: configuration?.VITE_SETTINGS_API_BASE_URL,
  liveopsApiBaseUrl: configuration?.VITE_LIVEOPS_API_BASE_URL,
  graphqlEndpointUrl: configuration?.VITE_GRAPHQL_ENDPOINT_URL,
  loginPageName: "login",
  localStoragePrefix: "voodootune",
  auth0: {
    domain: configuration?.VITE_AUTH_DOMAIN,
    audience: configuration?.VITE_AUTH_AUDIENCE,
    clientId: configuration?.VITE_AUTH_CLIENT_ID,
    callbackRedirectUrl: buildWithBaseUrl(configuration as AppEnv, configuration?.VITE_AUTH_CALLBACK_REDIRECT_URL),
    logoutRedirectUrl: buildWithBaseUrl(configuration as AppEnv, configuration?.VITE_AUTH_LOGOUT_REDIRECT_URL),
    jwksUrl: configuration?.VITE_AUTH0_JWKS_URL,
  },
  tracking: {
    logrocket: {
      apiKey: configuration?.VITE_LOGROCKET_KEY,
    },
    sentry: {
      dsn: configuration?.VITE_SENTRY_DSN,
    },
  },
};
